// import PropTypes from 'prop-types';
// // @mui
// import Box from '@mui/material/Box';
// import TableRow from '@mui/material/TableRow';
// import Checkbox from '@mui/material/Checkbox';
// import TableHead from '@mui/material/TableHead';
// import TableCell from '@mui/material/TableCell';
// import TableSortLabel from '@mui/material/TableSortLabel';

// // ----------------------------------------------------------------------

// const visuallyHidden = {
//   border: 0,
//   margin: -1,
//   padding: 0,
//   width: '1px',
//   height: '1px',
//   overflow: 'hidden',
//   position: 'absolute',
//   whiteSpace: 'nowrap',
//   clip: 'rect(0 0 0 0)',
// };

// // ----------------------------------------------------------------------

// export default function TableHeadCustom({
//   order,
//   orderBy,
//   rowCount = 0,
//   headLabel,
//   numSelected = 0,
//   onSort,
//   onSelectAllRows,
//   sx,
// }) {
//   return (
//     <TableHead sx={sx}>
//       <TableRow>
//         {onSelectAllRows && (
//           <TableCell padding="checkbox">
//             <Checkbox
//               indeterminate={!!numSelected && numSelected < rowCount}
//               checked={!!rowCount && numSelected === rowCount}
//               onChange={(event) => onSelectAllRows(event.target.checked)}
//             />
//           </TableCell>
//         )}

//         {headLabel.map((headCell ,index) => (
//           <TableCell
//             key={index}
//             align={headCell.align || 'left'}
//             sortDirection={orderBy === headCell.id ? order : false}
//             sx={{ width: headCell.width, minWidth: headCell.minWidth }}
//           >
//             {/* {onSort ? (
//               <TableSortLabel
//                 hideSortIcon
//                 active={orderBy === headCell.id}
//                 direction={orderBy === headCell.id ? order : 'asc'}
//                 onClick={() => onSort(headCell.id)}
//               >
//                 {headCell.label}

//                 {orderBy === headCell.id ? (
//                   <Box sx={{ ...visuallyHidden }}>
//                     {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
//                   </Box>
//                 ) : null}
//               </TableSortLabel>
//             ) : (
//               headCell.label
//             )} */}
//               {onSort ? (
//               <TableSortLabel
//                 hideSortIcon
//                 active={orderBy === headCell.id}
//                 direction={orderBy === headCell.id ? order : 'asc'}
//                 onClick={() => onSort(headCell.id)}
//               >
//                 {headCell.label}

//                 {orderBy === headCell.id ? (
//                   <Box sx={{ ...visuallyHidden }}>
//                     {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
//                   </Box>
//                 ) : null}
//               </TableSortLabel>
//             ) : (
//               headCell.label
//             )}
//           </TableCell>
//         ))}
//       </TableRow>
//     </TableHead>
//   );
// }

// TableHeadCustom.propTypes = {
//   sx: PropTypes.object,
//   onSort: PropTypes.func,
//   orderBy: PropTypes.string,
//   headLabel: PropTypes.array,
//   rowCount: PropTypes.number,
//   numSelected: PropTypes.number,
//   onSelectAllRows: PropTypes.func,
//   order: PropTypes.oneOf(['asc', 'desc']),
// };


import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

// ----------------------------------------------------------------------

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
};

// ----------------------------------------------------------------------

export default function TableHeadCustom({
  order,
  orderBy,
  rowCount = 0,
  headLabel,
  numSelected = 0,
  onSort,
  onSelectAllRows,
  onColumnResize,
  align,
  sx,
}) {
  const handleResizeStart = (event, headCell) => {
    event.preventDefault();
    event.stopPropagation();
    if (!onColumnResize || !headCell.resizable || !headCell.id) return;

    const cell = event.currentTarget.parentElement;
    const tableEl = cell?.closest('table');
    const startX = event.clientX;
    const startWidth = cell?.offsetWidth || Number(headCell.width || headCell.minWidth || 80);
    const minWidth = Number(headCell.minWidth || 50);
    const startTableMin = tableEl ? parseFloat(tableEl.style.minWidth) || tableEl.offsetWidth : 0;
    let lastWidth = startWidth;

    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';

    const onMove = (moveEvent) => {
      lastWidth = Math.max(minWidth, startWidth + (moveEvent.clientX - startX));
      if (cell) {
        cell.style.width = `${lastWidth}px`;
        cell.style.minWidth = `${lastWidth}px`;
      }
      if (tableEl) {
        tableEl.style.minWidth = `${startTableMin + (lastWidth - startWidth)}px`;
      }
    };

    const onUp = () => {
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      if (lastWidth !== startWidth) {
        onColumnResize(headCell.id, lastWidth);
      }
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  return (
    <TableHead sx={sx}>
      <TableRow>
        {onSelectAllRows && (
          <TableCell padding="checkbox" align={align || "left"}>
            <Checkbox
              indeterminate={!!numSelected && numSelected < rowCount}
              checked={!!rowCount && numSelected === rowCount}
              onChange={(event) => onSelectAllRows(event.target.checked)}
            />
          </TableCell>
        )}

        {headLabel.map((headCell, index) => {
          const canSort = Boolean(onSort && headCell.id && headCell.sortable !== false);
          const canResize = Boolean(onColumnResize && headCell.resizable && headCell.id);

          return (
            <TableCell
              key={headCell.id || index}
              align={headCell.align || 'left'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{
                position: 'relative',
                width: headCell.width,
                minWidth: headCell.minWidth,
                overflow: 'hidden',
              }}
            >
              {canSort ? (
                <TableSortLabel
                  hideSortIcon
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={() => onSort(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id && (
                    <Box sx={{ ...visuallyHidden }}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  )}
                </TableSortLabel>
              ) : (
                headCell.label
              )}

              {canResize && (
                <Box
                  onMouseDown={(event) => handleResizeStart(event, headCell)}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: 8,
                    height: 1,
                    cursor: 'col-resize',
                    zIndex: 2,
                    '&:hover': { bgcolor: 'primary.main', opacity: 0.35 },
                  }}
                />
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

TableHeadCustom.propTypes = {
  sx: PropTypes.object,
  onSort: PropTypes.func,
  orderBy: PropTypes.string,
  headLabel: PropTypes.array,
  rowCount: PropTypes.number,
  numSelected: PropTypes.number,
  onSelectAllRows: PropTypes.func,
  onColumnResize: PropTypes.func,
  order: PropTypes.oneOf(['asc', 'desc']),
};

